// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2400":"63ec9cb0051e3bce","2888":"32406328cda05b4f","7268":"17c3f939cc25fbcb"}[chunkId] + ".css";
};